/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-chart[_ngcontent-%COMP%]{padding:24px;margin-top:24px}"];
export { styles as styles };
